import React, { useState, useEffect } from 'react';
import { app } from '../firebase'; // Assurez-vous d'importer votre configuration Firebase
import { getFirestore, doc, getDoc, updateDoc, collection, query, where, getDocs, setDoc, arrayUnion, Timestamp } from 'firebase/firestore';
import { isProvider, isRentalManager, useUser } from '../contexts/UserContext';

function AddCoownershipAccount({ closeAction }) {
  const [code, setCode] = useState('');
  const [address, setAddress] = useState('');
  const [zip, setZip] = useState('');
  const [city, setCity] = useState('');
  const [loading, setLoading] = useState(false);
  const [coownershipId, setCoownershipId] = useState('');
  const [error, setError] = useState('');
  const [errorCodeImmeuble, setErrorCodeImmeuble] = useState('');
  const [successCodeImmeuble, setSuccessCodeImmeuble] = useState('');
  const [disabled, setDisabled] = useState(true);
  

  //contexte de l'utilisateur connecté
  const user = useUser();
  const firestore = getFirestore(app);

  console.log(user)

  // Vérifie le code immeuble quand il atteint 6 caractères
  useEffect(() => {
    if (code.length === 6) {
      checkCoownership();
    } else {
      invalidateCode();
      setSuccessCodeImmeuble('');
    }
  }, [code]);

  // Vérifie si le code correspond à une copropriété
  const checkCoownership = async () => {
    try {
      let coownershipQuery;

      if(isProvider(user.user)){
        // Vérification pour les prestataires 
        coownershipQuery = query(
          collection(firestore, 'coownership'),
          where('codeProvider', '==', code),
          where('status', '==', 'activated')
        );
      }else if(isRentalManager(user.user)){
        // Vérification pour les gestionnaires locatifs
        coownershipQuery = query(
          collection(firestore, 'coownership'),
          where('codeRentalManager', '==', code),
          where('status', '==', 'activated')
        );
      }

      if (!coownershipQuery) {
        invalidateCode();
        setErrorCodeImmeuble("Profil utilisateur non reconnu");
        return;
      }

      const querySnapshot = await getDocs(coownershipQuery);
      
      if (!querySnapshot.empty) {
        setCoownershipId(querySnapshot.docs[0].id);
        setDisabled(false);
        autoCompleteAddress(querySnapshot);
        return;
      }
      
      // Si aucun résultat, invalider le code
      invalidateCode();
      setErrorCodeImmeuble("Le code immeuble n'est pas valide");
      
    } catch (error) {
      console.error("Erreur lors de la vérification du code:", error);
      setErrorCodeImmeuble("Erreur lors de la vérification du code");
    }
  };

  // Réinitialise les champs pour un code invalide
  const invalidateCode = () => {
    setDisabled(true);
    setAddress('');
    setZip('');
    setCity('');
    setCoownershipId('');
    setErrorCodeImmeuble('');
  };

  // Remplit automatiquement les champs d'adresse
  const autoCompleteAddress = (querySnapshot) => {
    const data = querySnapshot.docs[0].data();
    setAddress(data.address || '');
    setCity(data.city || '');
    setZip(data.zip || '');
    
    setErrorCodeImmeuble('');
    setSuccessCodeImmeuble('Code immeuble valide');
  };

  // Ajoute la copropriété à la liste de l'utilisateur
  const addCoownership = async () => {
    if (!coownershipId) {
      setError("Veuillez entrer un code immeuble valide");
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // Utiliser directement les données du contexte utilisateur
      const userCoownerships = user?.user?.userData?.coownershipId || [];
      
      // Vérifier si la copropriété est déjà dans la liste
      const alreadyExists = userCoownerships.some(item => {
        // Vérifie si la référence contient l'ID de la copropriété
        return item.coownershipReference?.path?.includes(coownershipId);
      });
      
      if (alreadyExists) {
        setError("Cette copropriété est déjà enregistrée");
        setLoading(false);
        return;
      }
      
      // Ajouter la nouvelle copropriété et la définir comme copro active
      const userRef = doc(firestore, 'users', user?.user?.user?.uid);
      const coownershipRef = doc(firestore, 'coownership', coownershipId);
      await updateDoc(userRef, {
        coownershipId: arrayUnion({
          coownershipReference: coownershipRef
        }),
        lastCoownershipLoaded: coownershipRef,
      });

      let membershipData = {
        dateRegister: Timestamp.now(),
        firstname: user?.user?.userData?.firstname || '',
        lastname: user?.user?.userData?.lastname || '',
        email: user?.user?.userData?.email || '',
        phone: user?.user?.userData?.phone || ''
      }
      
      if(isProvider(user.user)){
        await setDoc(doc(firestore, 'coownership', coownershipId, 'usersProvider', user?.user?.user?.uid), membershipData);
      }else if(isRentalManager(user.user)){
        await setDoc(doc(firestore, 'coownership', coownershipId, 'usersRentalManager', user?.user?.user?.uid), membershipData);
      }

      // Mettre à jour le contexte avant le reload pour sortir de l'écran de choix
      let updatedUserData = {
        ...user.user.userData,
        lastCoownershipLoaded: coownershipRef,
        isLastCoownershipDeactivated: false,
      };

      const coownershipDoc = await getDoc(coownershipRef);
      if (coownershipDoc.exists()) {
        const data = coownershipDoc.data();
        updatedUserData.nameCoownershipLoaded = data.name;
        updatedUserData.codeOwner = data.codeOwner;
        updatedUserData.rentalManagerCreateContent = data.rentalManagerCreateContent ?? false;
      }

      user.setUser({ user: user.user.user, userData: updatedUserData });

      closeAction();

      window.location.reload();
      
    } catch (error) {
      console.error("Erreur lors de l'ajout de la copropriété:", error);
      setError("Une erreur est survenue, impossible d'ajouter cette copropriété");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-xl font-semibold text-primary">Ajouter une copropriété</h3>
          <button 
            onClick={closeAction}
            className="text-gray-400 hover:text-gray-500"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <div className="p-6">
          {/* Code Immeuble */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Code immeuble</label>
            <input
              type="text"
              className="w-full p-2 border rounded-md"
              placeholder="Entrez le code à 6 caractères"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              maxLength={6}
            />
            {errorCodeImmeuble && (
              <p className="text-red-500 text-sm mt-1">{errorCodeImmeuble}</p>
            )}
            {successCodeImmeuble && (
              <p className="text-green-500 text-sm mt-1">{successCodeImmeuble}</p>
            )}
          </div>
          
          {/* Affichage de l'adresse */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Adresse</label>
            <input
              type="text"
              className="w-full p-2 border rounded-md bg-gray-100"
              value={address}
              readOnly
            />
          </div>
          
          {/* Code postal et ville */}
          {zip && city && (
            <div className="flex space-x-4 mb-4">
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Code postal</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded-md bg-gray-100"
                  value={zip}
                  readOnly
                />
              </div>
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Ville</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded-md bg-gray-100"
                  value={city}
                  readOnly
                />
              </div>
            </div>
          )}
          
          {/* Message d'erreur */}
          {error && (
            <p className="text-red-500 text-sm mt-2 text-center">{error}</p>
          )}
          
          {/* Boutons */}
          <div className="flex justify-end mt-6 space-x-4">
            <button
              onClick={closeAction}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
            >
              Annuler
            </button>
            <button
              onClick={addCoownership}
              disabled={disabled || loading}
              className={`px-4 py-2 rounded-md text-sm font-medium text-white ${
                disabled 
                  ? "bg-gray-400 cursor-not-allowed" 
                  : "bg-primary hover:bg-opacity-90"
              }`}
            >
              {loading ? (
                <span className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Traitement en cours...
                </span>
              ) : (
                "Ajouter la copropriété"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCoownershipAccount;